export default __webpack_public_path__ + "static/media/AMAZON.287d5b91.png";